const types = require('../../constants/actionTypes');

const fetchCatalogueDetails = (fundResult) => ({
    type: types.FUNDS_CATALOGUE_SUCCEEDED,
    payload: { fundResult },
});

module.exports = fetchCatalogueDetails;
